import { render } from "./GatewayTypeForm.vue?vue&type=template&id=77b8469a&scoped=true"
import script from "./GatewayTypeForm.vue?vue&type=script&lang=js"
export * from "./GatewayTypeForm.vue?vue&type=script&lang=js"

import "./GatewayTypeForm.vue?vue&type=style&index=0&id=77b8469a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-77b8469a"

export default script